export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'proventi_access_token',
  USER: 'proventi_user',
  REMEMBER_ME: 'proventi_remember_me',
  BRANCH_CODE: 'proventi_branch_code',
  BRANCHES: 'proventi_branches',
  BRANCH_DETAIL: 'proventi_branch_detail',
  LOGIN_MODE: 'proventi_login_mode',
  BACKOFFICE_ACCESS_TOKEN: 'proventi_backoffice_access_token',
  BACKOFFICE_REMEMBER_ME: 'proventi_backoffice_remember_me',
  BACKOFFICE_USER: 'proventi_backoffice_user',
  /** UI language preference — retained across boot purge and logout. */
  UI_LOCALE: 'pro20.ui.locale',
} as const;

/**
 * Browser keys retained when purging non-session storage on boot.
 * Includes auth/branch keys and durable UI preferences (locale).
 */
export const PERSISTED_SESSION_KEYS = new Set<string>(Object.values(STORAGE_KEYS));
